import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface DeleteOrderDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  count: number;
  isProcessing?: boolean;
}

export default function DeleteOrderDialog({
  open,
  onClose,
  onConfirm,
  count,
  isProcessing = false,
}: DeleteOrderDialogProps) {
  const handleClose = () => {
    if (!isProcessing) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (!isProcessing) {
      onConfirm();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "510" }}>
        Cancel {count === 1 ? "Order" : "Orders"}?
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
          color: "rgba(0, 0, 0, 0.54)",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ width: 500, mt: -2 }}>
        <DialogContentText id="alert-dialog-description">
          <Typography sx={{ color: "rgba(0, 0, 0, 0.87)" }}>
            Are you sure you want to cancel{" "}
            {count === 1 ? "this order" : `these ${count} orders`}?
            <br />
            This action can't be undone.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleClose}
          disabled={isProcessing}
        >
          No
        </Button>
        <Button
          onClick={handleConfirm}
          autoFocus
          color="error"
          disabled={isProcessing}
          sx={{ ml: 2, mr: 1 }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

